import script from "./Mantenciones_Revisiones_Pendientes.vue?vue&type=script&setup=true&lang=js"
export * from "./Mantenciones_Revisiones_Pendientes.vue?vue&type=script&setup=true&lang=js"

import "./Mantenciones_Revisiones_Pendientes.vue?vue&type=style&index=0&id=b8915bd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b8915bd8"]])

export default __exports__